"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __publicField = (obj, key, value2) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import classNames from "classnames";
import Account from "../api/account";
import activityFormatter from "../formatters/activity";
import generalFormatter from "../formatters/general";
import factorInvoicesService from "./factor_invoices_service";
import SimpleHtmlFormat from "./simple_html_format";
import { Link } from "react-router";
import Auth from "../util/auth";
import DisablingButton from "../components/disabling_button";
import Transmissions from "../api/transmissions";
import React from "react";
class SentToCadenceActions extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      sending: false,
      sent: false,
      isUnapproved: false
    });
    __publicField(this, "send", () => {
      const component = this;
      this.setState({ sending: true });
      Transmissions.resend(this.props.item.data.transmission_id).then(() => {
        component.setState({ sending: false, sent: true });
      });
    });
  }
  componentDidMount() {
    const factorInvoice = factorInvoicesService.getFetchedWithId(
      this.props.item.owner_id
    );
    const isUnapproved = factorInvoice.state != "approved" && factorInvoice.state != "purchased";
    this.setState({ isUnapproved });
  }
  componentDidUpdate(prevProps) {
    if (this.props.item.owner_id !== prevProps.item.owner_id) {
      this.setState({ sent: false, sending: false });
    }
  }
  render() {
    const cadenceSuffix = `to CADENCE`;
    const buttonText = `Resend ${this.props.baseText} ${cadenceSuffix}`;
    const disabledText = `Resending ${this.props.baseText} ${cadenceSuffix}`;
    const sentText = `Resent ${this.props.baseText} ${cadenceSuffix}`;
    if (this.state.sent) {
      return /* @__PURE__ */ jsx("div", { className: "message--resent-to-cadence", children: sentText });
    } else if (this.state.isUnapproved) {
      return /* @__PURE__ */ jsx("div", { className: "message--resent-to-cadence", children: "Invoices have been un-approved and cannot be resent until re-approved" });
    } else {
      return /* @__PURE__ */ jsx("div", { "data-component": "SentToCadenceActions", children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.send,
          disabled: this.state.sending,
          disabledText,
          children: buttonText
        }
      ) });
    }
  }
}
class ApprovalActions extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      unapproving: false,
      unapproved: false,
      purchased: false,
      useSendToReceivables: false,
      sendingToReceivables: false
    });
    __publicField(this, "showUnapproveButton", (buttonText, disabledText) => {
      return /* @__PURE__ */ jsx(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.unapprove,
          disabled: this.state.unapproving,
          disabledText,
          children: buttonText
        }
      );
    });
    __publicField(this, "sendToReceivablesButtonIf", (useSendToReceivables) => {
      if (useSendToReceivables) {
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            disabledClassName: "button--disabled button--resend-to-cadence",
            className: "button--progress button--resend-to-cadence",
            onClick: this.sendToReceivables,
            disabled: this.state.sendingToReceivables,
            disabledText: "Sending to Receivables....",
            children: "Mark as Purchased and Send to Receivables"
          }
        );
      }
    });
    __publicField(this, "unapprove", () => {
      const component = this;
      this.setState({ unapproving: true });
      factorInvoicesService.unapproveInvoice(this.props.item.owner_id).then(() => {
        component.setState({ unapproving: false, unapproved: true });
      });
    });
    __publicField(this, "sendToReceivables", () => {
      const component = this;
      this.setState({ sendingToReceivables: true });
      factorInvoicesService.markInvoiceAsPurchased(this.props.item.owner_id).then(() => {
        component.setState({ sendingToReceivables: false, purchased: true });
      });
    });
  }
  componentDidMount() {
    const factorInvoice = factorInvoicesService.getFetchedWithId(
      this.props.item.owner_id
    );
    const isUnapproved = factorInvoice.state != "approved" && factorInvoice.state != "purchased";
    const isPurchased = factorInvoice.state == "purchased";
    const useSendToReceivables = Account.useSendToReceivables() && !factorInvoice.fuel_advance;
    this.setState({
      unapproved: isUnapproved,
      purchased: isPurchased,
      useSendToReceivables
    });
  }
  render() {
    const buttonText = `Un-approve ${this.props.baseText}`;
    const disabledText = `Un-approving ${this.props.baseText}`;
    const unapprovedText = `Un-approved ${this.props.baseText}`;
    if (this.state.unapproved) {
      return /* @__PURE__ */ jsx("div", { className: "message--resent-to-cadence", children: unapprovedText });
    } else if (this.state.purchased) {
      return /* @__PURE__ */ jsx("div", { className: "message--resent-to-cadence", children: "This invoice has been marked as purchased. Contact support to un-approve." });
    } else {
      return /* @__PURE__ */ jsxs("div", { "data-component": "ApprovalActions", children: [
        this.showUnapproveButton(buttonText, disabledText),
        this.sendToReceivablesButtonIf(this.state.useSendToReceivables)
      ] });
    }
  }
}
class SentToBrokerTMSActions extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      sending: false,
      sent: false
    });
    __publicField(this, "send", () => {
      const component = this;
      this.setState({ sending: true });
      Transmissions.resend(this.props.item.data.transmission_id).then(() => {
        component.setState({ sending: false, sent: true });
      });
    });
  }
  render() {
    const baseText2 = `this invoice`;
    const buttonText = `Resend ${baseText2}`;
    const disabledText = `Resending ${baseText2}`;
    const sentText = `Resent ${baseText2}`;
    if (this.state.sent) {
      return /* @__PURE__ */ jsx("div", { className: "message--resent-to-cadence", children: sentText });
    } else {
      return /* @__PURE__ */ jsx("div", { "data-component": "SentToBrokerTMSActions", children: /* @__PURE__ */ jsx(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.send,
          disabled: this.state.sending,
          disabledText,
          children: buttonText
        }
      ) });
    }
  }
}
function value(props, state) {
  if (state.expanded) {
    return props.value;
  } else {
    return /* @__PURE__ */ jsxs("span", { className: "activity-item__detail-line-code-collapsed", children: [
      "Click to show",
      /* @__PURE__ */ jsx("span", { className: "activity-item__detail-line-code-collapsed-period", children: "." })
    ] });
  }
}
class ExpandableCodeElement extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expanded: false
    });
    __publicField(this, "toggle", () => {
      this.setState({ expanded: !this.state.expanded });
    });
  }
  render() {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "ExpandableCodeElement",
        className: "activity-item__detail-line-code-value",
        onClick: this.toggle,
        children: /* @__PURE__ */ jsx("code", { children: value(this.props, this.state) })
      }
    );
  }
}
function possibleBody(body) {
  if (body) {
    return /* @__PURE__ */ jsx("div", { className: "activity-item__detail-full-body", children: /* @__PURE__ */ jsx(SimpleHtmlFormat, { text: body }) });
  }
}
function detailLink(element) {
  return /* @__PURE__ */ jsxs("div", { children: [
    "\u201C",
    /* @__PURE__ */ jsx(Link, { to: element.url, children: element.value }),
    "\u201D"
  ] });
}
function showValueDetail(element) {
  return /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-value", children: element.url ? element.newTab ? /* @__PURE__ */ jsx("a", { href: element.url, target: "_blank", rel: "noopener noreferrer", children: element.value }) : detailLink(element) : element.value });
}
function showLabel(label) {
  return /* @__PURE__ */ jsx("div", { className: "activity-item__detail-line-label", children: label });
}
class ActivityItemDetails extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "showCodeDetail", (element) => {
      const copyToClipboard = (str) => {
        const el = document.createElement("textarea");
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        element.hasBeenCopied = true;
        this.setState({ copied: true });
      };
      const message = element.hasBeenCopied ? "Data copied!" : "Copy to clipboard";
      return /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line-code-wrapper", children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            className: "button button--link",
            onClick: (_2) => copyToClipboard(element.code),
            children: message
          }
        ),
        /* @__PURE__ */ jsx(ExpandableCodeElement, { value: element.code })
      ] });
    });
    __publicField(this, "showLabeledElement", (element, index) => {
      const detail = element.code ? this.showCodeDetail(element) : showValueDetail(element);
      return /* @__PURE__ */ jsxs("div", { className: "activity-item__detail-line", children: [
        element.hasOwnProperty("label") && showLabel(element.label),
        detail
      ] }, "labeled-item-" + index);
    });
  }
  render() {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "activity-item__detail-labeled-elements",
        "data-component": "ActivityItemDetails",
        children: [
          _.map(
            this.props.formattedItem.labeled_elements,
            this.showLabeledElement
          ),
          possibleBody(this.props.formattedItem.body)
        ]
      }
    );
  }
}
function othersText(item) {
  const data = item.data;
  const othersCount = data.invoice_count - 1;
  const othersPlural = othersCount === 1 ? "other" : "others";
  return othersCount === 0 || isNaN(othersCount) ? "" : ` and ${othersCount} ${othersPlural} `;
}
function baseText(item) {
  return `this invoice ${othersText(item)}`;
}
function showApprovalActions(item) {
  return item.activity_type === "approval" && item.owner_type === "FactorInvoice" && Auth._currentUser.admin;
}
function showSendToCadenceActions(item) {
  return item.activity_type === "sent_to_cadence" && item.data.transmission_type === "cadence" && Auth._currentUser.admin;
}
function showSendToBrokerTMSActions(item) {
  return item.data && item.data.transmission_id && item.data.transmission_type != "cadence" && item.data.transmission_type != "turvo_make_payment" && Auth._currentUser.admin;
}
function possibleActions(item) {
  if (showSendToCadenceActions(item)) {
    return /* @__PURE__ */ jsx(SentToCadenceActions, { item, baseText: baseText(item) });
  } else if (showSendToBrokerTMSActions(item)) {
    return /* @__PURE__ */ jsx(SentToBrokerTMSActions, { item });
  } else if (showApprovalActions(item)) {
    return /* @__PURE__ */ jsx(ApprovalActions, { item, baseText: baseText(item) });
  }
}
function showItem(item, index) {
  var formattedItem = activityFormatter.format(item);
  var hasDetail = formattedItem.labeled_elements && formattedItem.labeled_elements.length > 0 || formattedItem.body;
  var classes = classNames({
    "activity-item__container": true,
    "activity-item__container--detailed": hasDetail
  });
  return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsxs("div", { className: "activity-item__body", children: [
    /* @__PURE__ */ jsxs("div", { className: "activity-item__meta", children: [
      /* @__PURE__ */ jsx("div", { className: "activity-item__user", children: formattedItem.user_name || "Temp User" }),
      /* @__PURE__ */ jsxs("div", { className: "activity-item__timestamp", children: [
        generalFormatter.shortDate(item.created_at),
        " ",
        generalFormatter.shortTime(item.created_at)
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "activity-item__title", children: formattedItem.title }),
    /* @__PURE__ */ jsx(ActivityItemDetails, { formattedItem }),
    possibleActions(item)
  ] }) }, "item-" + index);
}
function ActivityStream(props) {
  let detail;
  if (_.isEmpty(props.items)) {
    detail = /* @__PURE__ */ jsx("div", { className: "alert-box--highlight", children: "No Activity is available." });
  } else {
    detail = _.map(props.items, showItem);
  }
  return /* @__PURE__ */ jsx("div", { className: "activity-items", "data-component": "ActivityStream", children: detail });
}
export { ActivityStream };
